import fetch from '@rd-web-markets/shared/dist/services/Fetcher';
import { request } from '@rd-web-markets/shared/dist/services/request';
import QueryString from 'query-string';
const rndIntensityBySubsidiaryCompanies = {
  all(companyId, businessUnits, years, subsidiary_company_ids) {
    const query = QueryString.stringify({
      business_units: businessUnits,
      subsidiary_company_ids: subsidiary_company_ids,
      years: years
    }, {
      arrayFormat: 'comma'
    });
    return fetch(`/api/companies/${companyId}/rnd_intensity_by_subsidiary_companies?${query}`, request.get);
  }
};
export default rndIntensityBySubsidiaryCompanies;